import * as _ from 'lodash';
var ValidationService = /** @class */ (function () {
    function ValidationService() {
    }
    ValidationService.getValidatorErrorMessage = function (validatorName, validatorValue) {
        // console.log(validatorName);
        var config = {
            'required': 'Required',
            'invalidCreditCard': 'Is invalid credit card number',
            'invalidEmailAddress': 'Invalid email address',
            'invalidPassword': 'Invalid password. Password must be at least 6 characters long, and contain a number.',
            'minlength': "Minimum length " + validatorValue.requiredLength,
            'invalidNumber': 'Value must be number'
        };
        return config[validatorName];
    };
    ValidationService.creditCardValidator = function (control) {
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        if (control.value && control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
            return null;
        }
        else {
            return { 'invalidCreditCard': true };
        }
    };
    ValidationService.emailValidator = function (control) {
        // RFC 2822 compliant regex
        if (control.value && control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
            return null;
        }
        else {
            return { 'invalidEmailAddress': true };
        }
    };
    ValidationService.numberValidator = function (control) {
        // RFC 2822 compliant regex
        console.log('i am called');
        if (control.value && control.value.match(/[0-9]*/)) {
            return null;
        }
        else {
            return { 'invalidNumber': true };
        }
    };
    ValidationService.passwordValidator = function (control) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        if (control.value && control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/)) {
            return null;
        }
        else {
            return { 'invalidPassword': true };
        }
    };
    ValidationService.phoneNumberValidator = function (control) {
        try {
            var cellNumber = control.value;
            var state = -1;
            var invalidList = ["0", "1", "2", "3", "4", "5"];
            var validList = ["6", "7", "8", "9"];
            if (_.isNumber(cellNumber)) {
                cellNumber = String(cellNumber);
            }
            if (!_.isNaN(parseInt(cellNumber))) {
                state = 1;
            }
            if (cellNumber.length == 10) {
                if (state == 1) {
                    state = 2;
                }
            }
            if (invalidList.indexOf(cellNumber.substr(0, 1)) == -1) {
                if (state == 2) {
                    state = 3;
                }
            }
            if (validList.indexOf(cellNumber.substr(0, 1)) != -1) {
                if (state == 3) {
                    state = 4;
                }
            }
            if (state !== 4) {
                return { 'validPhone': true };
            }
        }
        catch (error) {
            return { 'validPhone': true };
        }
    };
    ValidationService.noWhitespaceValidator = function (control) {
        var isWhitespace = (control.value || '').toString().trim().length === 0;
        var isValid = !isWhitespace;
        return isValid ? null : { 'whitespace': true };
    };
    return ValidationService;
}());
export { ValidationService };



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/shared/utilities/validation.service.ts.pre-build-optimizer.js